import { Link } from "react-router-dom";
import { Phone, ArrowRight, Scale } from "lucide-react";
import { COMPANY } from "../lib/constants";
import useSeo from "../lib/useSeo";

const SECTIONS = [
  {
    id: "editeur",
    title: "Éditeur du site",
    body: (
      <>
        <p>
          Le présent site est édité sous la marque{" "}
          <strong>MON SERRURIER BRETON</strong>, exploitée par la société{" "}
          <strong>ABITA MULTISERVICES</strong>, EURL (société à responsabilité
          limitée à associé unique) au capital social de <strong>2 500 €</strong>,
          immatriculée au Registre du Commerce et des Sociétés de Rennes sous
          le numéro <strong>100 801 877 RCS Rennes</strong>, numéro EUID{" "}
          <strong>FR3501.100801877</strong>.
        </p>
        <div className="mt-6 rounded-2xl bg-slate-50 border border-slate-200 p-6 space-y-2">
          <div className="text-xs uppercase tracking-widest text-teal-700 font-bold">
            Siège social
          </div>
          <div className="font-semibold text-slate-900">ABITA MULTISERVICES</div>
          <div className="text-slate-700">
            5, Allée de la Grande Treille, Bureau 3, 35200 Rennes
          </div>
          <div className="pt-2 text-sm text-slate-700 space-y-1">
            <div>
              Téléphone :{" "}
              <a
                href={`tel:${COMPANY.phoneDigits}`}
                className="text-teal-700 font-semibold hover:underline"
                data-testid="legal-phone"
              >
                {COMPANY.phone}
              </a>
            </div>
            <div>
              Adresse email :{" "}
              <a
                href="mailto:contact@monserrurierbreton.fr"
                className="text-teal-700 font-semibold hover:underline break-all"
              >
                contact@monserrurierbreton.fr
              </a>
            </div>
          </div>
        </div>
        <p className="mt-6">
          <strong>MON SERRURIER BRETON</strong>, une marque de l'EURL{" "}
          <strong>ABITA MULTISERVICES</strong>, est une entreprise spécialisée
          en serrurerie, dépannage, installation, ouverture de portes,
          remplacement de cylindres et serrures, pour les particuliers et les
          professionnels.
        </p>
      </>
    ),
  },
  {
    id: "hebergement",
    title: "Hébergement",
    body: <p>Ce site est hébergé par la société <strong>WIX</strong>.</p>,
  },
  {
    id: "donnees",
    title: "Données personnelles",
    body: (
      <>
        <p>
          Les données collectées sur ce site sont destinées{" "}
          <strong>exclusivement à MON SERRURIER BRETON</strong>. Elles sont
          strictement confidentielles et conservées à des fins de gestion des
          relations commerciales, de prospection et de statistiques.
        </p>
        <p>
          Conformément aux dispositions de la loi «&nbsp;Informatique et
          Libertés&nbsp;» du 6 janvier 1978 modifiée, ainsi qu'au Règlement
          Général sur la Protection des Données (RGPD), vous disposez d'un
          droit d'accès, de modification, de rectification et de suppression
          des données vous concernant.
        </p>
        <p>
          Pour exercer ces droits, vous pouvez adresser votre demande par email
          à :{" "}
          <a
            href="mailto:contact@monserrurierbreton.fr"
            className="text-teal-700 font-semibold hover:underline break-all"
          >
            contact@monserrurierbreton.fr
          </a>
        </p>
        <p>
          À chaque fois que des données à caractère personnel sont collectées
          sur le site, les conditions juridiques de collecte et/ou de
          modification sont expressément rappelées.
        </p>
      </>
    ),
  },
  {
    id: "conditions",
    title: "Conditions d'utilisation",
    body: (
      <p>
        Ce site est soumis à la <strong>loi française</strong>. En consultant
        ce site, vous acceptez d'en respecter les conditions d'utilisation
        telles qu'elles sont affichées à la date de consultation.
      </p>
    ),
  },
  {
    id: "objet",
    title: "Objet du site",
    body: (
      <>
        <p>
          Le présent site diffuse des informations contractuelles et non
          contractuelles relatives aux offres de services de{" "}
          <strong>MON SERRURIER BRETON</strong>.
        </p>
        <p>
          Malgré le soin apporté à la mise à jour des informations, certaines
          données peuvent devenir obsolètes ou inexactes. MON SERRURIER BRETON
          ne peut garantir l'exactitude, la complétude ou l'actualité
          permanente des informations diffusées sur le site.
        </p>
      </>
    ),
  },
  {
    id: "propriete",
    title: "Propriété intellectuelle",
    body: (
      <>
        <p>
          Le contenu de ce site, incluant son architecture, ses textes,
          photographies, illustrations et logiciels, est la propriété exclusive
          de MON SERRURIER BRETON ou de ses partenaires techniques.
        </p>
        <p>
          Les marques, logos et signes distinctifs présents sur ce site sont
          protégés par le droit de la propriété intellectuelle. Toute
          reproduction, représentation ou exploitation, totale ou partielle,
          sans autorisation préalable est strictement interdite et constitue
          une contrefaçon au sens de l'article <strong>L.122-4</strong> du Code
          de la Propriété Intellectuelle, sanctionnée par les articles{" "}
          <strong>L.335-2</strong> et suivants du même code.
        </p>
      </>
    ),
  },
  {
    id: "liens",
    title: "Liens hypertextes",
    body: (
      <p>
        MON SERRURIER BRETON peut proposer des liens vers des sites externes.
        Ces sites étant indépendants, MON SERRURIER BRETON n'exerce aucun
        contrôle sur leur contenu et décline toute responsabilité quant aux
        informations, produits ou services qui y sont proposés.
      </p>
    ),
  },
  {
    id: "responsabilite",
    title: "Responsabilité",
    body: (
      <>
        <p>
          Ni MON SERRURIER BRETON, ni ses dirigeants ou collaborateurs ne
          peuvent être tenus responsables de dommages directs ou indirects
          résultant de l'utilisation de ce site.
        </p>
        <p>
          MON SERRURIER BRETON se réserve le droit de modifier, suspendre ou
          interrompre tout ou partie du site à tout moment, sans préavis.
        </p>
        <p>
          Les utilisateurs s'engagent à ne pas introduire de contenu illicite,
          nuisible ou malveillant. En cas de non-respect, leur responsabilité
          pourra être engagée et des poursuites judiciaires pourront être
          intentées.
        </p>
      </>
    ),
  },
  {
    id: "mediation",
    title: "Médiation de la consommation",
    body: (
      <>
        <p>
          En cas de litige entre le Client et l'entreprise, les parties
          s'efforceront de le résoudre à l'amiable. Le Client adressera une
          réclamation écrite au professionnel.
        </p>
        <p>
          À défaut d'accord amiable ou en l'absence de réponse dans un délai
          d'<strong>un (1) mois</strong>, le Client consommateur, au sens de
          l'article <strong>L.133-4</strong> du Code de la consommation, peut
          saisir gratuitement le médiateur compétent inscrit sur la liste
          officielle prévue à l'article <strong>L.615-1</strong> du Code de la
          consommation.
        </p>
        <p>
          Ici, dans cet établissement, le médiateur de la consommation est le{" "}
          <strong>
            CM2C — Centre de la Médiation de la Consommation de Conciliateurs
            de Justice
          </strong>
          . En cas de litige de consommation, vous pouvez le déclarer
          directement sur la plate-forme CM2C.
        </p>
        <div className="mt-6 rounded-3xl bg-teal-50 border border-teal-200 p-6 md:p-8">
          <div className="flex flex-col md:flex-row gap-6 items-start md:items-center">
            <div className="flex-shrink-0 bg-white rounded-2xl p-4 border border-slate-200 shadow-sm">
              <img
                src="https://customer-assets-jt897jd0.emergentagent.net/job_urgence-serrurier/artifacts/9u1r0nrx_Capture%20d%E2%80%99e%CC%81cran%202026-08-03%20a%CC%80%2011.35.32.png"
                alt="Logo CM2C — Centre de la Médiation de la Consommation de Conciliateurs de Justice"
                className="h-20 md:h-24 w-auto object-contain"
                data-testid="cm2c-logo"
                loading="lazy"
              />
            </div>
            <div className="flex-1 space-y-2">
              <div className="text-xs uppercase tracking-widest text-teal-700 font-bold">
                Médiateur de la consommation
              </div>
              <div className="font-display font-extrabold text-slate-900 text-lg leading-tight">
                CM2C — Centre de la Médiation de la Consommation
                <br />
                de Conciliateurs de Justice
              </div>
              <div className="text-sm text-slate-700 pt-2 space-y-1">
                <div>49 rue de Ponthieu, 75008 Paris</div>
                <div>
                  Email :{" "}
                  <a
                    href="mailto:contact@cm2c.net"
                    className="text-teal-700 font-semibold hover:underline"
                    data-testid="cm2c-email"
                  >
                    contact@cm2c.net
                  </a>
                </div>
                <div>
                  Téléphone :{" "}
                  <a
                    href="tel:+33189470014"
                    className="text-teal-700 font-semibold hover:underline"
                    data-testid="cm2c-phone"
                  >
                    01 89 47 00 14
                  </a>
                </div>
                <div className="pt-1">
                  Plate-forme :{" "}
                  <a
                    href="https://www.cm2c.net"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-teal-700 font-semibold hover:underline break-all"
                    data-testid="cm2c-website"
                  >
                    www.cm2c.net
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ),
  },
];

export default function MentionsLegales() {
  useSeo({
    title: "Mentions légales | Mon Serrurier Breton",
    description:
      "Mentions légales du site monserrurierbreton.fr — éditeur ABITA MULTISERVICES, hébergement, données personnelles, propriété intellectuelle, médiation.",
    path: "/mentions-legales",
    robots: "noindex, follow",
  });
  return (
    <div data-testid="page-mentions-legales">
      {/* Hero */}
      <section className="max-w-5xl mx-auto px-4 md:px-8 pt-12 md:pt-20 pb-10">
        <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
          <Scale className="w-4 h-4" /> Informations légales
        </div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter text-slate-900 leading-[0.95]">
          Mentions <span className="text-teal-600">légales</span>.
        </h1>
        <p className="text-slate-600 mt-5 leading-relaxed max-w-2xl">
          Informations obligatoires sur l'éditeur, l'hébergement, la
          confidentialité et les conditions d'utilisation du site
          monserrurierbreton.fr.
        </p>
      </section>

      {/* Layout: sticky TOC + content */}
      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 bg-white border border-slate-200 rounded-3xl p-6">
              <div className="text-xs font-bold uppercase tracking-widest text-teal-700 mb-3">
                Sommaire
              </div>
              <ol className="space-y-2 text-sm">
                {SECTIONS.map((s, i) => (
                  <li key={s.id}>
                    <a
                      href={`#${s.id}`}
                      data-testid={`toc-${s.id}`}
                      className="flex items-start gap-3 text-slate-700 hover:text-teal-700 transition-colors"
                    >
                      <span className="font-display font-black text-slate-300 w-6 flex-shrink-0">
                        0{i + 1}
                      </span>
                      <span>{s.title}</span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>
          </aside>

          <div className="lg:col-span-8 space-y-10">
            {SECTIONS.map((s, i) => (
              <article
                key={s.id}
                id={s.id}
                data-testid={`legal-section-${s.id}`}
                className="scroll-mt-32"
              >
                <div className="flex items-baseline gap-3 mb-4">
                  <span className="font-display text-slate-300 font-black text-lg">
                    0{i + 1}
                  </span>
                  <h2 className="font-display text-2xl md:text-3xl font-extrabold text-slate-900">
                    {s.title}
                  </h2>
                </div>
                <div className="space-y-4 text-slate-700 leading-relaxed">
                  {s.body}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-5xl mx-auto px-4 md:px-8 pb-20">
        <div className="rounded-3xl bg-slate-900 text-white p-10 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-extrabold tracking-tight">
              Une question ? Un besoin d'intervention ?
            </h2>
            <p className="text-slate-300 mt-2">
              Nous sommes joignables 24h/24, 7j/7.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              data-testid="legal-cta-call"
              href={`tel:${COMPANY.phoneDigits}`}
              className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-full px-6 py-4 shadow-xl"
            >
              <Phone className="w-5 h-5" /> {COMPANY.phone}
            </a>
            <Link
              data-testid="legal-cta-contact"
              to="/contact"
              className="inline-flex items-center gap-2 bg-white text-slate-900 font-bold rounded-full px-6 py-4"
            >
              Formulaire <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
